module.exports = __webpack_public_path__ + "img/medi.d1a011b3.png";